import { render, staticRenderFns } from "./UserManagement.vue?vue&type=template&id=1b652534"
import script from "./userManagement.ts?vue&type=script&lang=js&external"
export * from "./userManagement.ts?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports